// App
//import { ToolType } from '../../components/tooltype/ToolType'
import { ShowHiddenElement } from './methods/ShowHiddenElement'
import { CallModalWindow } from './methods/CallModalWindow'
import { edproFaqAccordion, edproFaqOpen } from '../../components/faq/faq'
import { edproSwiperGraduates, edproSwiperTeachers } from '../../components/swiper/edpro-swiper'
import { edproCardOpen } from '../../components/card/card'
import { edproInput } from '../../components/form/form'
import { edproTeachers, edproGraduates, edproAuthor, edproAnchor } from '../../content/content'

window.addEventListener('DOMContentLoaded', function() {
    //ToolType('js-tooltype')
    ShowHiddenElement('js-animation-height')
    CallModalWindow()

    edproAnchor()

    edproFaqAccordion()
    edproFaqOpen()

    edproAuthor()


    edproSwiperGraduates()
    edproSwiperTeachers()

    edproCardOpen()

    edproInput()

    edproTeachers()
    edproGraduates()
})
